import * as Utils from 'Assets/Utils'

import ClientHttpRequest from 'Api/ClientHttpRequest'
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initiaState = Immutable.Map({})
  .set('GetValuation', new Immutable.List([]))
  .set('GetValuationSelected', new Immutable.List([]))
  .set('UpdateValuation', new Immutable.Map({}))
  .set('GetIntegralEvaluation', new Immutable.List([]))
  .set('RunValuation', new Immutable.Map({}))
  .set('SaveValuation', new Immutable.Map({}))
  .set('PublishValuation', new Immutable.Map({}))

/*Types*/
export const ACTION_GET_INTEGRAL_VALUATION = "ACTION_GET_INTEGRAL_VALUATION"
export const ACTION_GET_INTEGRAL_VALUATION_SELECTED = "ACTION_GET_INTEGRAL_VALUATION_SELECTED"
export const ACTION_UPDATE_INTEGRAL_VALUATION = "ACTION_UPDATE_INTEGRAL_VALUATION"
export const ACTION_GET_INTEGRAL_EVALUATION = "ACTION_GET_INTEGRAL_EVALUATION"
export const ACTION_RUN_INTEGRAL_VALUATION = "ACTION_RUN_INTEGRAL_VALUATION"
export const ACTION_SAVE_INTEGRAL_VALUATION = "ACTION_SAVE_INTEGRAL_VALUATION"
export const ACTION_PUBLISH_INTEGRAL_VALUATION = "ACTION_PUBLISH_INTEGRAL_VALUATION"

/*Reducers*/
export default (state = initiaState, action) => {

  switch (action.type) {
    case ACTION_GET_INTEGRAL_VALUATION:
      return state.set('GetValuation', new Immutable.List(action.Obj))
    case ACTION_GET_INTEGRAL_VALUATION_SELECTED:
      return state.set('GetValuationSelected', new Immutable.List(action.Obj))
    case ACTION_UPDATE_INTEGRAL_VALUATION:
      return state.set('UpdateValuation', new Immutable.Map(action.Obj))
    case ACTION_GET_INTEGRAL_EVALUATION:
      return state.set('GetIntegralEvaluation', new Immutable.List(action.Obj))
    case ACTION_RUN_INTEGRAL_VALUATION:
      return state.set('RunValuation', new Immutable.Map(action.Obj))
    case ACTION_SAVE_INTEGRAL_VALUATION:
      return state.set('SaveValuation', new Immutable.Map(action.Obj))
    case ACTION_PUBLISH_INTEGRAL_VALUATION:
      return state.set('PublishValuation', new Immutable.Map(action.Obj))
    default:
      return state
  }
}

/*Action Creators*/

export const getIntegralValuation = (idEjecutivo) => {
  return (dispatch) => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getIntegralValuation',
      method: 'POST',
      data: { idEjecutivo },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))
      dispatch({ type: ACTION_GET_INTEGRAL_VALUATION, Obj: response.data })
      return response
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const getIntegralEvaluation = (idDonataria) => {

  return (dispatch) => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getIntegralEvaluation',
      method: 'POST',
      data: { idDonataria },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))
      dispatch({ type: ACTION_GET_INTEGRAL_EVALUATION, Obj: response.data })
      return response
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const updateIntegralValuationContainer = (form) => {

  let request = []

  form.data.map((i) => {
    let obj = {
      donataria: {
        id: i.id
      },
      correcto: i.correcto
    }
    request.push(obj)
  })


  return (dispatch) => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/updateIntegralValuationContainer',
      method: 'POST',
      data: { request },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))
      dispatch({ type: ACTION_UPDATE_INTEGRAL_VALUATION, Obj: response.data })
      return response
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const saveIntegralValuation = (form) => {
  let tmp = {
    donataria: {
      id: form.idDonataria
    },
    valoracion: {
      id: form.valuationSelection
    },
    comentario: form.valuationComments,
    objetivoNMP: form.goalNMP,
    observacion: form.executiveObservations
  }

  return (dispatch) => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/saveIntegralValuation',
      method: 'POST',
      data: { ...tmp },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))
      dispatch({ type: ACTION_SAVE_INTEGRAL_VALUATION, Obj: response.data })
      return response.data
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const runIntegralValuation = (idEjecutivo) => {

  return (dispatch) => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/runIntegralValuation',
      method: 'POST',
      data: { idEjecutivo },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))
      dispatch({ type: ACTION_RUN_INTEGRAL_VALUATION, Obj: response.data })
      return response
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const publishIntegralValuation = (idEjecutivo) => {

  return (dispatch) => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/publishIntegralValuation',
      method: 'POST',
      data: { idEjecutivo },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))
      dispatch({ type: ACTION_PUBLISH_INTEGRAL_VALUATION, Obj: response.data })
      return response
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const clearData = () => {
  return (dispatch) => {
    dispatch({ type: ACTION_GET_INTEGRAL_VALUATION, Obj: []} )
  }
}




// WEBPACK FOOTER //
// ./src/modules/IntegralValuation/IntegralValuation.js